import React from 'react';
import styled from 'styled-components';
import { DesignPalette } from '../data/designTemplates';

const PreviewCard = styled.div<{ $palette: DesignPalette }>`
  position: relative;
  width: 100%;
  aspect-ratio: 920 / 420;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${({ $palette }) => $palette.border};
  background: ${({ $palette }) => $palette.cream};
`;

const PreviewGradient = styled.div<{ $palette: DesignPalette }>`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 46%;
  background: ${({ $palette }) => $palette.gradient};
`;

const PreviewTitleBar = styled.div<{ $palette: DesignPalette }>`
  position: absolute;
  top: 22%;
  left: 8%;
  width: 34%;
  height: 12%;
  border-radius: 3px;
  background: ${({ $palette }) => $palette.text};
  opacity: 0.85;
`;

const PreviewTextBar = styled.div<{ $palette: DesignPalette; $top: string; $width: string }>`
  position: absolute;
  left: 8%;
  top: ${({ $top }) => $top};
  width: ${({ $width }) => $width};
  height: 6%;
  border-radius: 3px;
  background: ${({ $palette }) => $palette.textMuted};
  opacity: 0.55;
`;

const PreviewPhoto = styled.div`
  position: absolute;
  top: 24%;
  right: 8%;
  width: 26%;
  height: 52%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
`;

const DesignPreview: React.FC<{ palette: DesignPalette }> = ({ palette }) => (
  <PreviewCard $palette={palette} aria-hidden>
    <PreviewGradient $palette={palette} />
    <PreviewTitleBar $palette={palette} />
    <PreviewTextBar $palette={palette} $top="44%" $width="30%" />
    <PreviewTextBar $palette={palette} $top="56%" $width="26%" />
    <PreviewTextBar $palette={palette} $top="68%" $width="28%" />
    <PreviewPhoto />
  </PreviewCard>
);

export default DesignPreview;
